import React from "react";
import cx from "classnames";
import { PromotionStatus, CampaignStatus } from "utils/promotionConstants";

interface StatusConfig {
  label: string;
  bgClass: string;
  textClass: string;
  borderClass: string;
}

interface PromotionStatusBadgeProps {
  status?: string;
  size?: "sm" | "md" | "lg";
  className?: string;
}

const getStatusConfig = (status?: string): StatusConfig => {
  const statusMap: Record<string, StatusConfig> = {
    // Status field values (waiting, available, blocked)
    [CampaignStatus.WAITING]: {
      label: "Đang chờ",
      bgClass: "bg-processing/10",
      textClass: "text-processing",
      borderClass: "border-processing/30"
    },
    [CampaignStatus.AVAILABLE]: {
      label: "Sẵn sàng",
      bgClass: "bg-done/10",
      textClass: "text-done",
      borderClass: "border-done/30"
    },
    [CampaignStatus.BLOCKED]: {
      label: "Đã chặn",
      bgClass: "bg-cancel/10",
      textClass: "text-cancel",
      borderClass: "border-cancel/30"
    },
    // PromotionStatus field values (for backward compatibility)
    [PromotionStatus.UPCOMING]: {
      label: "Sắp diễn ra",
      bgClass: "bg-info/10",
      textClass: "text-info",
      borderClass: "border-info/30"
    },
    [PromotionStatus.ACTIVE]: {
      label: "Đang hoạt động",
      bgClass: "bg-done/10",
      textClass: "text-done",
      borderClass: "border-done/30"
    },
    [PromotionStatus.EXPIRED]: {
      label: "Đã hết hạn",
      bgClass: "bg-error/10",
      textClass: "text-error",
      borderClass: "border-error/30"
    }
  };

  const normalizedStatus = status?.toLowerCase() || CampaignStatus.BLOCKED;
  return statusMap[normalizedStatus] || statusMap[CampaignStatus.BLOCKED];
};

const getSizeClasses = (size: "sm" | "md" | "lg") => {
  const sizeMap = {
    sm: "px-2 py-0.5 text-xs",
    md: "px-3 py-1 text-xs",
    lg: "px-4 py-1.5 text-sm"
  };
  return sizeMap[size];
};

export default function PromotionStatusBadge({
  status,
  size = "md",
  className = ""
}: PromotionStatusBadgeProps) {
  if (!status) return null;

  const statusConfig = getStatusConfig(status);
  const sizeClasses = getSizeClasses(size);

  return (
    <span
      className={cx(
        "inline-flex items-center rounded-full font-medium border shadow-sm",
        statusConfig.bgClass,
        statusConfig.textClass,
        statusConfig.borderClass,
        sizeClasses,
        className
      )}
    >
      {statusConfig.label}
    </span>
  );
}